import { useTranslation } from 'react-i18next';
import { FormControl, Stack } from '@mui/material';

import { CustomFormLabel, RHFMaskedPhoneTextField, RHFTextField } from '@/components/form-controls';

import { AgreementField } from '../../components/AgreementField';

type RegistrationFormFieldsProps = {
  isPhoneDisabled?: boolean;
};

export const RegistrationFormFields = (props: RegistrationFormFieldsProps) => {
  const { isPhoneDisabled = false } = props;
  const { t } = useTranslation('auth-sign-up');

  return (
    <Stack spacing={3} mb={7}>
      <FormControl fullWidth>
        <CustomFormLabel htmlFor="firstName" isRequired>
          {t('forms.registration-form.labels.first-name')}
        </CustomFormLabel>
        <RHFTextField fullWidth name="firstName" id="firstName" variant="filled" />
      </FormControl>

      <FormControl fullWidth>
        <CustomFormLabel htmlFor="lastName" isRequired>
          {t('forms.registration-form.labels.last-name')}
        </CustomFormLabel>
        <RHFTextField fullWidth name="lastName" id="lastName" variant="filled" />
      </FormControl>

      <FormControl fullWidth>
        <CustomFormLabel htmlFor="phoneNumber" isRequired>
          {t('forms.registration-form.labels.phone-number')}
        </CustomFormLabel>
        <RHFMaskedPhoneTextField
          fullWidth
          name="phoneNumber"
          id="phoneNumber"
          variant="filled"
          disabled={isPhoneDisabled}
        />
      </FormControl>
      <AgreementField name="isAgree" />
    </Stack>
  );
};
